<template>
    <TimeConstraintList
            v-if="currentDayTemplate"
            :constrainedItem="currentDayTemplate && currentDayTemplate"
            :timeConstraintType="timeConstraintType"
            :allow-period-selection=false
    />
</template>
<script>
    import {mapState, mapMutation} from "vuex";
    import TimeConstraintList from "@/components/common/TimeConstraintList";
    import TimeConstraintApis from "@/apis/_apiTimeConstraints";

    export default {
        components: {TimeConstraintList},
        computed: {
            ...mapState({
              currentDayTemplate: state => state.currentDayTemplate
            })
        },
        data() {
            return {
                viewState: {
                    showNewPanel: false
                },
                timeConstraintType:
                TimeConstraintApis.TIME_CONSTRAINT_TYPES.DAY_TEMPLATE.value
            };
        },
    };
</script>